import { render, staticRenderFns } from "./giveQuestionBankCourse.vue?vue&type=template&id=28a4eb6c"
import script from "./giveQuestionBankCourse.vue?vue&type=script&lang=js"
export * from "./giveQuestionBankCourse.vue?vue&type=script&lang=js"
import style0 from "./giveQuestionBankCourse.vue?vue&type=style&index=0&id=28a4eb6c&prod&lang=less&scope=true"
import style1 from "./giveQuestionBankCourse.vue?vue&type=style&index=1&id=28a4eb6c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports